import { defineStore } from "pinia";

export  const useMainStore = defineStore('mainStore', {
    state: () => ({ 
        isLoaded: false,
        isStarted: false,
        isModalPrimaryVisible: false,
        isModalSecondaryVisible: false,
        isModalTertiaryVisible: false,
        isModalQuaternaryVisible: false,
        isModalQuinquenaryVisible: false,
        isMuted: true,
        isBottomBarActive: false,
        is3DActive: false,
        currentModalTitle: '', 
        currentModalDescription: '' ,
        currentCategory:'chuletero',
        currentSpecific:null,
        windowWidth:null,
        showBueyFull: false
    }),
  })